import React from 'react';
import ToastDisplay from '@components/toast/ToastDisplay';
import ToastStore from '@store/toast/ToastStore';
import connectToStores from 'alt-utils/lib/connectToStores';
import './ToastContainer.sass';

@connectToStores
class ToastContainer extends React.Component<ReturnType<typeof ToastContainer.getPropsFromStores>> {
  static getStores() {
    return [ToastStore];
  }
  static getPropsFromStores() {
    return {toasts: ToastStore.getState().toasts};
  }
  render() {
    const toasts = this.props.toasts;
    const topCenter = toasts.filter(t => t.position === 'top-center');
    const bottomRight = toasts.filter(t => t.position === 'bottom-right');

    return (
      <div className="toast-container">
        <div className="anchor top-center">
          {topCenter.map(toast => (
            <ToastDisplay key={toast.id} toast={toast} />
          ))}
        </div>
        <div className="anchor bottom-right">
          {bottomRight.map(toast => (
            <ToastDisplay key={toast.id} toast={toast} />
          ))}
        </div>
      </div>
    );
  }
}

export default ToastContainer as unknown as React.FC;
